import styled from "styled-components";
import { theme } from "../../../constants/StyledComponents";

export const StyledContentDownloadCollaboratorChip = styled.div<{
  $isDraggable?: boolean;
  $isCalibration?: boolean;
}>`
  display: flex;
  flex-direction: row;
  align-items: start;
  justify-content: start;
  width: 100%;
  padding: 0 2px;
`;

export const StyledNameDownloadCollaboratorChip = styled.span`
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  min-width: 0;
  color: ${theme.colors.black};
  font-family: ${theme.variables.font_family};
  font-weight: ${theme.variables.fw_medium};
  font-size: 7px;
`;
